import { createAction } from '@reduxjs/toolkit';

export const payrollPaymentSetupStart = createAction(
    'PAYROLL_PAYMENT_SETUP::START',
);
export const payrollPaymentSetupComplete = createAction(
    'PAYROLL_PAYMENT_SETUP::COMPLETE',
);
